import React from 'react';
import * as firebase from 'firebase';
import 'firebase/firestore';

//const verifyCallback = token => {
  // Here you will get the final token!!!
  //console.log(token, 'verifycallback')
//}

const config = {
    apiKey: "AIzaSyABg7t_gZxfKVeMRBualeUWNbSDoPVuAPc",
    authDomain: "tirika-c4fb0.firebaseapp.com",
    databaseURL: "https://tirika-c4fb0.firebaseio.com",
    projectId: "tirika-c4fb0",
    storageBucket: "tirika-c4fb0.appspot.com",
    messagingSenderId: "235212786999",
    appId: "1:235212786999:web:a70f4a7057e99eab305eb2"
};

firebase.initializeApp(config);

//export default firebase;

class RequestInfo extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
     email: "",
     fullname: "",
     country: "",
     message: ""
    };
  }

  updateInput = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  showAlert(type, message) {
    this.setState({
      alert: true,
      alertData: { type, message }
    });
    setTimeout(() => {
      this.setState({ alert: false });
    }, 40000)
  }

  addRequest = e => {
    e.preventDefault();
    const db = firebase.firestore();
    db.settings({
      //timestampsInSnapshots: true
    });
    console.log('name', this.state.fullname);
    if (this.state.fullname && this.state.email && this.state.country && this.state.message) {
      console.log('si_name', this.state.fullname);
      const requestRef = db.collection("requestinfo").add({
        fullname: this.state.fullname,
        email: this.state.email,
        country: this.state.country,
        message: this.state.message,
        date: new Date().toUTCString()
      });  
      this.setState({
        fullname: "",
        email: "",
        country: "",
        message: ""
      });
      this.showAlert('success', 'Your message was sent successfully, if it has passed a week and we have not got back at you please send us an email to info@tirikaexpeditions.com (also, check your spam folder just in case) ;)');
    } else {
      console.log('no_name', this.state.fullname);
      this.showAlert('warning', 'Please fill the form');
    };
  };

  render() {
    return (
      <div>
        
        <div className="card">
          <img src={require('../images/lostWorld/_akopan_Panorama1a.jpg')} className="card-img" alt=""/>
          <div className="card-img-overlay">
            
            <p className="card-text"></p>
            <p className="card-text"></p>
          </div>
        </div>

        <div className="m-4">
        <br/><br/>
        <p className="h5">For more detailed information about any of our trips or if you have an idea you want us to help with, please fill the form below</p>
        <br/>
        </div>
        
        <div className="m-4">
        {this.state.alert && <div className={`alert alert-${this.state.alertData.type}`} role='alert'>
          <div className='container'>
            {this.state.alertData.message}
          </div>
        </div>}
        <form onSubmit={this.addRequest}>
          <div className="form-group col-md-4">
          <label htmlFor="fullname">Full Name</label>
          <input className="form-control"
            id="fullname"
            type="text"
            name="fullname"
            placeholder=""
            onChange={this.updateInput}
            value={this.state.fullname}
          />
          </div>
          
          <div className="form-group col-md-4">
          <label htmlFor="email">Email</label>
          <input className="form-control"
            id="email"
            type="email"
            name="email"
            placeholder=""
            onChange={this.updateInput}
            value={this.state.email}
          />
          </div>

          <div className="form-group col-md-4">
          <label htmlFor="country">Country</label>
          <input className="form-control"
            id="country"
            type="text"
            name="country"
            placeholder=""
            onChange={this.updateInput}
            value={this.state.country}
          />
          </div>

          <div className="form-group col-md-4">
          <label htmlFor="message">How can we help?</label>
          <textarea className="form-control"
            id="message"
            name="message"
            onChange={this.updateInput}
            value={this.state.message}
            rows="3"
          />
          </div>

          <div className="form-group col-md-4">
          <button type="submit" className="form-control btn btn-primary">Submit</button>
          </div>
          
          <br/><br/>
        </form>
        {this.state.alert && <div className={`alert alert-${this.state.alertData.type}`} role='alert'>
          <div className='container'>
            {this.state.alertData.message}
          </div>
        </div>}
        You can also reach us at info@tirikaexpeditions.com
        </div>
      </div>  
        );
      }
   }
export default RequestInfo;


// WEBPACK FOOTER //
// ./src/components/request_info.jsx